import { render, staticRenderFns } from "./AutoInvestStrategies.vue?vue&type=template&id=29b908f1&scoped=true&"
import script from "./AutoInvestStrategies.vue?vue&type=script&lang=js&"
export * from "./AutoInvestStrategies.vue?vue&type=script&lang=js&"
import style0 from "./AutoInvestStrategies.vue?vue&type=style&index=0&id=29b908f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b908f1",
  null
  
)

export default component.exports